import { ENVS } from "../config/constants"

/**
 * Dominios que deben usar la configuracion del entorno de desarrollo.
 *
 * `window.location.hostname` retorna solo el nombre del dominio, sin protocolo,
 * puerto, ruta ni slash final. Mantener estos valores en ese mismo formato.
 */
const DEV_HOSTS = [
    "localhost",
    "nf-app-makemake.reallabs.com.co",
]

const DEFAULT_COMERCIAL_PATH = "/"

/**
 * Resuelve el entorno de la aplicacion a partir del dominio actual del navegador.
 *
 * @returns {"DEV" | "PROD"} `"DEV"` para dominios de desarrollo conocidos; de lo contrario, `"PROD"`.
 */
export function getEnvByHost() {
    if (DEV_HOSTS.includes(window.location.hostname)) {
        return ENVS.development
    }

    return ENVS.production
}

const MAKEMAKE_COMERCIAL_URL = {
    [ENVS.development]: "https://nf-conoce-makemake.reallabs.com.co",
    [ENVS.production]: "https://info.makemake.com.co",
}

function getMakeMakeComercialUrlByEnv(env) {
    return MAKEMAKE_COMERCIAL_URL[env] || MAKEMAKE_COMERCIAL_URL[ENVS.production]
}

function normalizePath(path = DEFAULT_COMERCIAL_PATH) {
    if (!path) {
        return DEFAULT_COMERCIAL_PATH
    }

    return path.startsWith("/") ? path : `/${path}`
}

/**
 * Construye una URL absoluta hacia el sitio comercial de MakeMake segun el entorno.
 *
 * @param {Object} params - Parametros para construir la URL.
 * @param {string} [params.path="/"] - Ruta interna del sitio comercial.
 * @param {Object} [params.queryParams] - Parametros que se agregan al query string.
 * @param {string} [params.hash] - Fragmento de la URL, sin el simbolo `#`.
 * @param {"DEV" | "PROD"} [params.env] - Entorno destino. Por defecto usa el dominio actual.
 * @returns {string} URL absoluta del sitio comercial para el entorno indicado.
 */
export function buildMakeMakeComercialUrlByEnv({
    path = DEFAULT_COMERCIAL_PATH,
    queryParams,
    hash,
    env = getEnvByHost(),
} = {}) {
    const url = new URL(normalizePath(path), getMakeMakeComercialUrlByEnv(env))

    if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                url.searchParams.set(key, value)
            }
        })
    }

    if (hash) {
        url.hash = hash
    }

    return url.toString()
}
